// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JTJ2","title":"styles_title__2jo7I"};